import {ITimeBookingDetailVm, ProxyContainer} from "../Data/Data";
import {LogoutService} from "./LogoutService";

export class BookingDataService {

  static serviceId = "BookingDataService";
  static $inject = [
    '$proxy',
    LogoutService.serviceId,
  ];

  constructor(private proxy: ProxyContainer,
              private logout: LogoutService) {

  }

  browse(employeeId: number) {
    return this.logout.catchLogoutResponse(
      this.proxy.TimeBooking.browseMultiple({}, {
        employeeId: employeeId,
        skip: 0,
        take: 30,
      })
    ).then(res => res.data);
  }

  get(bookingId: string) {
    return this.logout.catchLogoutResponse(
      this.proxy.TimeBooking.getTimebookingDetail({id: bookingId})
    ).then(res => res.data);
  }

  create(booking: ITimeBookingDetailVm) {
    return this.logout.catchLogoutResponse(this.proxy.TimeBooking.saveBooking(booking));
  }

  save(booking: ITimeBookingDetailVm) {
    return this.logout.catchLogoutResponse(this.proxy.TimeBooking.saveBooking(booking));
  }

  delete(bookingId: string) {
    return this.logout.catchLogoutResponse(this.proxy.TimeBooking.delete({id: bookingId}));
  }
}